import { useState, useCallback, useEffect } from "react";
import { AdListing } from "types/adListing";
import { ListingSortOption } from "api/utils/listingMapper";
import { listingService } from "api/services/ListingService";
import { sortOptionToOrderBy } from "api/utils/listingMapper";
import { listingViewModelToAdListing } from "api/utils/listingMapper";

export function usePendingListings() {
    const [listings, setListings] = useState<AdListing[]>([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const [fetchError, setFetchError] = useState<string | null>(null);
    const [sortOption, setSortOption] = useState<ListingSortOption>('newest');
  
    const fetchListings = useCallback(async () => {
      setLoading(true);
      setFetchError(null);
      const result = await listingService.getAll({
        StatusId: 4, // 4 is the status id for pending listings
        Pagination: {
          pageSize: pageSize,
          pageNumber: currentPage,
        },
        OrderBy: sortOptionToOrderBy(sortOption),
      });
      if (result.isSuccess && result.data) {
        setListings(result.data.map(listingViewModelToAdListing));
        setTotalPages(result.pagination?.totalPageCount ?? 1);
      } else {
        setListings([]);
        setTotalPages(1);
        setFetchError(result.message ?? 'Liste alınamadı.');
      }
      setLoading(false);
    }, [sortOption, pageSize, currentPage]);
  
    useEffect(() => {
      fetchListings();
    }, [fetchListings]);
  
    return {
      listings,
      totalPages,
      currentPage,
      pageSize,
      loading,
      fetchError,
      sortOption,
      setSortOption,
      fetchListings,
      setCurrentPage,
      setPageSize,
    }
  }
  